import React from 'react'
import get from 'lodash/get'

import { paramsForUploadLogoEmployer } from 'api/employers'

import ImageUploadBlock from 'components/UploadInput/imageUploadNew'

import { BoxFill, H2 } from 'styles'

type Props = {
  form: any
  title: string
}

const Third: React.FC<Props> = ({ form, title }) => {
  const link = get(form, 'logoFile.link', '')
  return (
    <BoxFill column bbDefault padding="30px 40px 0">
      <BoxFill mb="20px" spaceBetween>
        <H2 black fw="bold">
          Edit {title.toLocaleLowerCase()}
        </H2>
      </BoxFill>
      <ImageUploadBlock id={form.id} photo={link} paramsForUploading={paramsForUploadLogoEmployer} />
    </BoxFill>
  )
}

export default Third
